module.exports = __webpack_public_path__ + "static/media/great-support.b6918a9f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/great-support.jpg
// module id = 918
// module chunks = 0